import { render, staticRenderFns } from "./CtrlRegionWiseView.vue?vue&type=template&id=517efcbe&scoped=true&"
import script from "./CtrlRegionWiseView.vue?vue&type=script&lang=js&"
export * from "./CtrlRegionWiseView.vue?vue&type=script&lang=js&"
import style0 from "./CtrlRegionWiseView.vue?vue&type=style&index=0&id=517efcbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517efcbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCol,VRow,VSimpleTable})
